import { apiSlice } from "../api/apiSlice";

export const quizMarkApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		submitQuiz: builder.mutation({
            query: (data) => ({
                url: "/quizMark",
                method: "POST",
                body: data
            })
        }),
        getQuizMarks: builder.query({
            query: () => "/quizMark"
        }),
        getQuizMarkByVideoIdAndStudentId: builder.query({
            query: ({videoId, studentId}) => `/quizMark?video_id=${videoId}&student_id=${studentId}`
        })
	}),
});

export const { 
    useSubmitQuizMutation,
    useGetQuizMarksQuery,
    useGetQuizMarkByVideoIdAndStudentIdQuery,
} = quizMarkApi;
